import { render, staticRenderFns } from "./Administration_Packing.vue?vue&type=template&id=1d6ee92f"
import script from "./Administration_Packing.vue?vue&type=script&lang=js"
export * from "./Administration_Packing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports